import { AxiosResponse } from 'axios'
import IComprovanteTransferenciaDTO from 'modules/pagamentos/domain/entities/IComprovanteTransferencia'
import { ITransferenciaRepository } from 'modules/pagamentos/domain/repositories/ITransferenciaRepository'
import { ServiceConfig } from 'shared/services/ServiceConfig'

const http = new ServiceConfig()
export default class TransferenciaRepository
  implements ITransferenciaRepository
{
  async getComprovante(
    data: IComprovanteTransferenciaDTO,
  ): Promise<ArrayBuffer> {
    const response: AxiosResponse = await http.get(
      '/transferencias/comprovante',
      {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/pdf',
          data: data.data,
          frotista_id: data.frotista_id,
          'frotista-id': data.frotista_id,
        },
      },
    )

    return response.data
  }
}
